(function () {
  'use strict';

  var language = localStorage.getItem('kalumi-language') === 'en' ? 'en' : 'zh';
  var assetRoot = window.KALUMI_ASSET_ROOT || '';

  var products = [
    { code: 'K01-1', price: 25, stem: 'k01-1', line: 'ESSENTIAL / 2026', description: { zh: '宽幅织带、柔软脚床与扎实结构，为日常移动而设计。', en: 'Wide woven straps, a soft footbed and a robust build made for everyday movement.' }, variants: [['卡其棕', 'Brown khaki', 'k01-1-front.jpg', '#b48b51'], ['黑灰橙', 'Black grey orange', 'k01-1-v2.jpg', '#353535'], ['黑米棕', 'Black beige brown', 'k01-1-v3.jpg', '#8c765e'], ['黑色', 'Black', 'k01-1-v4.jpg', '#111111']] },
    { code: 'K01-2', price: 25, stem: 'k01-2', line: 'URBAN / 2026', description: { zh: '单色视觉、鲜明纹理与厚实鞋底，适合城市穿着。', en: 'A monochrome look, bold texture and a substantial sole made for the city.' }, variants: [['军绿', 'Military green', 'k01-2-front.jpg', '#515640'], ['藏蓝', 'Navy', 'k01-2-v2.jpg', '#182845'], ['米色', 'Beige', 'k01-2-v3.jpg', '#d1bea0'], ['红色', 'Red', 'k01-2-v4.jpg', '#a3262e'], ['黑色', 'Black', 'k01-2-v5.jpg', '#111111']] },
    { code: 'K01-3', price: 29, stem: 'k01-3', line: 'ADJUST / 2026', description: { zh: '可调节鞋面、柔软夹层与当代轮廓，适配多种造型。', en: 'An adjustable upper, cushioned layers and a contemporary, versatile silhouette.' }, variants: [['白色', 'White', 'k01-3-front.jpg', '#eeeeee'], ['深灰', 'Dark grey', 'k01-3-v2.jpg', '#4c4c4c'], ['藏蓝', 'Navy', 'k01-3-v3.jpg', '#172640'], ['红色', 'Red', 'k01-3-v4.jpg', '#9f242c'], ['黑色', 'Black', 'k01-3-v5.jpg', '#111111']] },
    { code: 'K01-6', price: 27, stem: 'k01-6', line: 'PRO / 2026', description: { zh: '运动结构、金属对比与贴合脚型的设计，塑造鲜明个性。', en: 'A sport structure, metallic contrast and anatomical fit with a strong identity.' }, variants: [['黑金', 'Black gold', 'k01-6-front.jpg', '#b99146'], ['军绿', 'Military green', 'k01-6-v2.jpg', '#535d42'], ['灰橙', 'Grey orange', 'k01-6-v3.jpg', '#df6326'], ['灰色', 'Grey', 'k01-6-v4.jpg', '#777777'], ['白色', 'White', 'k01-6-v5.jpg', '#eeeeee'], ['黑色', 'Black', 'k01-6-v6.jpg', '#111111']] },
    { code: 'K02-1', price: 25, stem: 'k02-1', line: 'GRAPHIC / 2026', description: { zh: '独特图案、材质拼接与全天候舒适感。', en: 'Distinctive graphics, layered materials and comfort designed for every day.' }, variants: [['卡其', 'Khaki', 'k02-1-front.jpg', '#c29a63'], ['灰色', 'Grey', 'k02-1-v2.jpg', '#888888'], ['绿色', 'Green', 'k02-1-v3.jpg', '#52654a'], ['黑色', 'Black', 'k02-1-v4.jpg', '#111111']] },
    { code: 'K02', price: 26, stem: 'k02-2', line: 'AIR / 2026', description: { zh: '流畅线条、结构化侧边与轻盈脚床，呈现科技感。', en: 'Fluid lines, structured sides and a lightweight footbed with a technical edge.' }, variants: [['月光蓝', 'Lunar blue', 'k02-2-front.jpg', '#85b7c7'], ['卡其', 'Khaki', 'k02-2-v2.jpg', '#bba27c'], ['浅灰', 'Light grey', 'k02-2-v3.jpg', '#bbbbbb'], ['黑色', 'Black', 'k02-2-v4.jpg', '#111111']] },
    { code: 'K03', price: 23, stem: 'k03', line: 'CLASSIC / 2026', description: { zh: 'KALUMI 经典鞋型，搭配宽幅织带与金属标识。', en: 'The essential KALUMI shape with wide textile straps and a metallic signature.' }, variants: [['宝蓝', 'Royal blue', 'k03-front.jpg', '#087dcc'], ['藏蓝', 'Navy', 'k03-v2.jpg', '#172a4a'], ['红色', 'Red', 'k03-v3.jpg', '#b0202d'], ['黑橙', 'Black orange', 'k03-v4.jpg', '#e85d18'], ['黑色', 'Black', 'k03-v5.jpg', '#111111']] },
    { code: 'K05', price: 25, stem: 'k05', line: 'SLIDE / 2026', description: { zh: '简洁拖鞋轮廓、交叉鞋面与齿纹外底，轻松兼顾舒适。', en: 'A clean slide profile, crossed upper and lugged sole for effortless comfort.' }, variants: [['米色', 'Beige', 'k05-front.jpg', '#ddd3be'], ['藏蓝', 'Navy', 'k05-v2.jpg', '#182a49'], ['米黑', 'Beige black', 'k05-v3.jpg', '#b4a183'], ['酒红', 'Wine', 'k05-v4.jpg', '#71323b'], ['黑色', 'Black', 'k05-v5.jpg', '#111111']] },
    { code: 'K05-3', price: 23, stem: 'k05-3', line: 'CLUB / 2026', description: { zh: '球迷文化图案、抓地外底与撞色细节的全新演绎。', en: 'A graphic club-inspired design with a traction sole and contrast details.' }, variants: [['藏蓝', 'Navy', 'k05-3-front.jpg', '#14274e'], ['米黑', 'Beige black', 'k05-3-v2.jpg', '#c2ab87'], ['黑橙', 'Black orange', 'k05-3-v3.jpg', '#ed651e'], ['黑红', 'Black red', 'k05-3-v4.jpg', '#bd2028'], ['黑绿', 'Black green', 'k05-3-v5.jpg', '#377044']] },
    { code: 'K06-1', price: 34, stem: 'k06-1', line: 'SCULPT / 2026', description: { zh: '雕塑感体积、立体侧片与醒目的缓震视觉。', en: 'Sculpted volume, raised side detailing and visually bold cushioning.' }, variants: [['酒红', 'Wine', 'k06-1-front.jpg', '#74313a'], ['深灰', 'Dark grey', 'k06-1-v2.jpg', '#4d4d4d'], ['藏蓝', 'Navy', 'k06-1-v3.jpg', '#182943'], ['黑色', 'Black', 'k06-1-v4.jpg', '#111111']] },
    { code: 'K06-5', price: 31, stem: 'k06-5', line: 'MOTION / 2026', description: { zh: '动感纹路、深层鞋底与高密度鞋带，打造城市存在感。', en: 'A kinetic pattern, deep base and dense straps for a strong urban presence.' }, variants: [['黑白', 'Black white', 'k06-5-front.jpg', '#202020'], ['军绿', 'Military green', 'k06-5-v2.jpg', '#566047'], ['藏蓝', 'Navy', 'k06-5-v3.jpg', '#182943'], ['黑红', 'Black red', 'k06-5-v4.jpg', '#b42029']] }
  ];

  function asset(name) { return assetRoot + name; }
  function textFor(node) {
    var value = node.getAttribute('data-' + language);
    if (value !== null) node.textContent = value;
  }
  function applyLanguage(next) {
    language = next === 'en' ? 'en' : 'zh';
    localStorage.setItem('kalumi-language', language);
    document.documentElement.lang = language === 'zh' ? 'zh-CN' : 'en';
    document.querySelectorAll('[data-zh][data-en]').forEach(textFor);
    document.querySelectorAll('[data-placeholder-zh]').forEach(function (node) {
      node.placeholder = node.getAttribute('data-placeholder-' + language) || '';
    });
    document.querySelectorAll('[data-language]').forEach(function (button) {
      button.classList.toggle('active', button.getAttribute('data-language') === language);
    });
    renderCatalog();
    renderCartSurfaces();
    if (activeProduct) fillModal(activeProduct, activeVariant);
  }

  document.querySelectorAll('[data-language]').forEach(function (button) {
    button.addEventListener('click', function () { applyLanguage(button.getAttribute('data-language')); });
  });

  var grid = document.getElementById('catalog-grid');
  var search = document.getElementById('catalog-search');
  var empty = document.getElementById('empty-result');
  var modal = document.getElementById('product-modal');
  var activeProduct = null;
  var activeVariant = 0;
  var activeAngle = 0;

  function variantName(variant) { return language === 'zh' ? variant[0] : variant[1]; }
  function cardMarkup(product, index) {
    var swatches = product.variants.map(function (variant) { return '<i style="background:' + variant[3] + '"></i>'; }).join('');
    return '<article class="product-card"><button class="product-open" data-product="' + product.code + '">' +
      '<div class="product-index">' + String(index + 1).padStart(2, '0') + ' / ' + String(products.length).padStart(2, '0') + '</div>' +
      '<div class="product-media"><img class="product-image" src="' + asset(product.variants[0][2]) + '" alt="KALUMI ' + product.code + '"><span>' + (language === 'zh' ? '点击查看多角度细节' : 'VIEW ALL ANGLES') + '</span></div>' +
      '<div class="product-data"><small>' + product.line + '</small><h2>KALUMI ' + product.code + '</h2><strong>¥' + product.price + '</strong><div class="swatches">' + swatches + '</div></div>' +
      '</button></article>';
  }
  function renderCatalog() {
    if (!grid) return;
    var query = search ? search.value.trim().toUpperCase() : '';
    var visible = products.filter(function (product) { return !query || product.code.indexOf(query) !== -1 || ('KALUMI ' + product.code).indexOf(query) !== -1; });
    grid.innerHTML = visible.map(cardMarkup).join('');
    if (empty) empty.hidden = visible.length !== 0;
    grid.querySelectorAll('[data-product]').forEach(function (button) {
      button.addEventListener('click', function () {
        var product = products.find(function (item) { return item.code === button.getAttribute('data-product'); });
        openModal(product);
      });
    });
  }

  function anglesFor(product, variantIndex) {
    var variant = product.variants[variantIndex];
    var number = variantIndex + 1;
    return [variant[2], product.stem + '-v' + number + '-a2.jpg', product.stem + '-v' + number + '-a3.jpg', product.stem + '-v' + number + '-a4.jpg'];
  }
  function setAngle(product, variantIndex, angleIndex) {
    activeAngle = angleIndex;
    var files = anglesFor(product, variantIndex);
    var main = document.getElementById('gallery-main');
    if (main) { main.src = asset(files[angleIndex]); main.alt = 'KALUMI ' + product.code + ' — ' + variantName(product.variants[variantIndex]); }
    document.querySelectorAll('#angle-list button').forEach(function (button, index) { button.classList.toggle('active', index === angleIndex); });
  }
  function fillModal(product, variantIndex) {
    if (!modal || !product) return;
    activeProduct = product;
    activeVariant = variantIndex;
    activeAngle = 0;
    document.getElementById('modal-line').textContent = product.line;
    document.getElementById('modal-name').textContent = 'KALUMI ' + product.code;
    document.getElementById('modal-price').textContent = '¥' + product.price;
    document.getElementById('modal-description').textContent = product.description[language];
    document.getElementById('modal-code').textContent = product.code;
    document.getElementById('modal-count').textContent = product.variants.length;
    var feedback = document.getElementById('cart-feedback');
    if (feedback) feedback.hidden = true;
    document.getElementById('variant-label').textContent = language === 'zh' ? '配色：' + variantName(product.variants[variantIndex]) : 'COLOR: ' + variantName(product.variants[variantIndex]);
    var angleList = document.getElementById('angle-list');
    angleList.innerHTML = anglesFor(product, variantIndex).map(function (file, index) { return '<button class="' + (index === 0 ? 'active' : '') + '" data-angle="' + index + '" aria-label="' + (language === 'zh' ? '角度 ' : 'Angle ') + (index + 1) + '"><img src="' + asset(file) + '" alt=""></button>'; }).join('');
    angleList.querySelectorAll('button').forEach(function (button) { button.addEventListener('click', function () { setAngle(product, variantIndex, Number(button.getAttribute('data-angle'))); }); });
    var variantList = document.getElementById('variant-list');
    variantList.innerHTML = product.variants.map(function (variant, index) { return '<button class="' + (index === variantIndex ? 'active' : '') + '" data-variant="' + index + '" aria-label="' + variantName(variant) + '"><img src="' + asset(variant[2]) + '" alt=""><span style="background:' + variant[3] + '"></span></button>'; }).join('');
    variantList.querySelectorAll('button').forEach(function (button) { button.addEventListener('click', function () { fillModal(product, Number(button.getAttribute('data-variant'))); }); });
    setAngle(product, variantIndex, 0);
  }
  function openModal(product) {
    fillModal(product, 0);
    modal.hidden = false;
    document.body.classList.add('modal-open');
    document.getElementById('modal-close').focus();
  }
  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('modal-open');
    activeProduct = null;
  }

  function money(cents) { return '¥' + (Number(cents || 0) / 100).toFixed(2).replace(/\.00$/, ''); }
  function productHandle(product) { return 'kalumi-' + product.code.toLowerCase(); }
  async function fetchCart() {
    var response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  }
  async function addActiveProductToCart() {
    if (!activeProduct) return;
    var feedback = document.getElementById('cart-feedback');
    var button = document.getElementById('add-cart-button');
    if (button) button.disabled = true;
    try {
      var productResponse = await fetch('/products/' + productHandle(activeProduct) + '.js', { headers: { Accept: 'application/json' } });
      if (!productResponse.ok) throw new Error('Product unavailable');
      var shopifyProduct = await productResponse.json();
      var variant = shopifyProduct.variants[activeVariant] || shopifyProduct.variants[0];
      var addResponse = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }) });
      if (!addResponse.ok) throw new Error('Add failed');
      await renderCartSurfaces();
      if (feedback) {
        feedback.textContent = language === 'zh' ? '已加入购物车。' : 'Added to cart.';
        feedback.hidden = false;
      }
    } catch (error) {
      if (feedback) {
        feedback.textContent = language === 'zh' ? '暂时无法加入，请稍后重试。' : 'Unable to add. Please try again.';
        feedback.hidden = false;
      }
    } finally {
      if (button) button.disabled = false;
    }
  }
  function updateCartBadges(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (node) { node.textContent = cart.item_count || 0; });
  }
  function cartRowMarkup(item) {
    return '<article class="cart-row" data-cart-key="' + encodeURIComponent(item.key) + '"><img src="' + (item.image || '') + '" alt="' + item.product_title + '"><div><small>' + item.variant_title + '</small><h2>' + item.product_title + '</h2><strong>' + money(item.final_price) + '</strong></div><div class="cart-row-actions"><div class="quantity-control"><button type="button" data-cart-action="minus" aria-label="Minus">−</button><span>' + item.quantity + '</span><button type="button" data-cart-action="plus" aria-label="Plus">+</button></div><button class="remove-cart-item" type="button" data-cart-action="remove">' + (language === 'zh' ? '移除' : 'REMOVE') + '</button></div></article>';
  }
  function checkoutLineMarkup(item) {
    return '<div class="checkout-line"><img src="' + (item.image || '') + '" alt=""><div><b>' + item.product_title + '</b><small>' + item.variant_title + ' × ' + item.quantity + '</small></div><strong>' + money(item.final_line_price) + '</strong></div>';
  }
  async function changeCartItem(key, action) {
    var cart = await fetchCart();
    var item = cart.items.find(function (entry) { return entry.key === key; });
    if (!item) return;
    var quantity = item.quantity;
    if (action === 'plus') quantity += 1;
    if (action === 'minus') quantity -= 1;
    if (action === 'remove') quantity = 0;
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) }) });
    await renderCartSurfaces();
  }
  function bindCartActions() {
    document.querySelectorAll('[data-cart-action]').forEach(function (button) {
      button.addEventListener('click', function () {
        var row = button.closest('[data-cart-key]');
        if (row) changeCartItem(decodeURIComponent(row.getAttribute('data-cart-key')), button.getAttribute('data-cart-action'));
      });
    });
  }
  async function renderCartSurfaces() {
    try {
      var cart = await fetchCart();
      updateCartBadges(cart);
      var cartItems = document.getElementById('cart-items');
      if (cartItems) {
        cartItems.innerHTML = cart.items.length ? cart.items.map(cartRowMarkup).join('') : '<div class="empty-cart"><h2>' + (language === 'zh' ? '购物车还是空的' : 'YOUR CART IS EMPTY') + '</h2><a href="/pages/catalog">' + (language === 'zh' ? '查看全部款式' : 'EXPLORE MODELS') + '</a></div>';
        bindCartActions();
      }
      var cartTotalNode = document.getElementById('cart-total');
      if (cartTotalNode) cartTotalNode.textContent = money(cart.total_price);
      var checkoutButton = document.getElementById('checkout-button');
      if (checkoutButton) checkoutButton.classList.toggle('disabled', cart.items.length === 0);
      var checkoutItems = document.getElementById('checkout-items');
      if (checkoutItems) checkoutItems.innerHTML = cart.items.length ? cart.items.map(checkoutLineMarkup).join('') : '<p>' + (language === 'zh' ? '购物车为空。' : 'Your cart is empty.') + '</p>';
      var checkoutTotal = document.getElementById('checkout-total');
      if (checkoutTotal) checkoutTotal.textContent = money(cart.total_price);
    } catch (error) {
      updateCartBadges({ item_count: 0 });
    }
  }

  if (search) search.addEventListener('input', renderCatalog);
  if (modal) {
    document.getElementById('modal-close').addEventListener('click', closeModal);
    document.getElementById('add-cart-button').addEventListener('click', addActiveProductToCart);
    modal.addEventListener('click', function (event) { if (event.target === modal) closeModal(); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !modal.hidden) closeModal(); });
    var zoomStage = document.getElementById('zoom-stage');
    zoomStage.addEventListener('mousemove', function (event) {
      var image = document.getElementById('gallery-main');
      var rect = zoomStage.getBoundingClientRect();
      image.style.transformOrigin = ((event.clientX - rect.left) / rect.width * 100) + '% ' + ((event.clientY - rect.top) / rect.height * 100) + '%';
    });
    zoomStage.addEventListener('mouseleave', function () { document.getElementById('gallery-main').style.transformOrigin = 'center'; });
  }

  applyLanguage(language);
})();
